import translation from 'locales/translation';
import { useCallback, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useHistory } from 'react-router-dom';

import api from 'api/Assessor/evento';

import { Button, Typography } from '@material-ui/core';
import { CircleCheck, CircleTimes, SyncIcon } from 'components/Icons';
import Modal, {
  IGenericModalProps,
} from 'components/Modal/__LEGACY__/GenericModal/GenericModal';

import { AssessorRoutePath } from 'library/Routes';

import { assembleiasAssessorActionsLoadEventoList } from 'store/modules/AssembleiasAssessorActions';
import { modalsActionsClose } from 'store/modules/ModalsActions';
import { IModalProps } from 'store/modules/ModalsReducer';

import ErrorHandler from 'helpers/utils/ErrorHandler';

import useStyle from './style';

export interface ExcluirModalGenericProps extends IGenericModalProps {
  key: string;
  idEvento: number;
}

export interface ExcluirModalProps extends IModalProps {
  genericProps: ExcluirModalGenericProps;
}

export default function ExcluirModal({
  genericProps,
  open,
}: ExcluirModalProps) {
  const classes = useStyle();
  const dispatch = useDispatch();
  const history = useHistory();

  const [excluindo, setExcluindo] = useState<boolean>(false);

  const handleClose = useCallback(() => {
    dispatch(modalsActionsClose(genericProps.key));
  }, [dispatch, genericProps]);

  const excluir = useCallback(async () => {
    setExcluindo(true);
    const { fail, response } = await api.evento.excluir(genericProps.idEvento);
    setExcluindo(false);
    if (fail) {
      ErrorHandler(fail);
    }
    if (response && response.status === 200) {
      dispatch(assembleiasAssessorActionsLoadEventoList());
      handleClose();
      history.replace(AssessorRoutePath);
    }
  }, [genericProps, history, handleClose, dispatch]);

  return (
    <Modal
      open={open ?? false}
      title={translation.SubMenus.excluirEvento.tituloModal}
      genericProps={{
        maxWidth: 'sm',
        onClose: handleClose,
        DialogContentProps: {
          className: classes.content,
        },
        footerContent: (
          <footer className={classes.footer}>
            <Button
              variant='outlined'
              color='primary'
              startIcon={<CircleTimes />}
              onClick={handleClose}
              disabled={excluindo}
            >
              {translation.SubMenus.excluirEvento.cancelar}
            </Button>
            <Button
              variant='contained'
              color='primary'
              startIcon={
                excluindo ? <SyncIcon animated /> : <CircleCheck noFill />
              }
              onClick={excluir}
              disabled={excluindo}
            >
              {translation.SubMenus.excluirEvento.confirmar}
            </Button>
          </footer>
        ),
      }}
      content={
        <Typography className={classes.text}>
          {translation.SubMenus.excluirEvento.textoModal}
        </Typography>
      }
    />
  );
}
